module.exports = __webpack_public_path__ + "img/fileeob.a37276b9.svg";